import { MeReadDtoLangEnum } from "@/config/apiClient";

const mappingComplexLocales: Partial<Record<MeReadDtoLangEnum, string>> = {
  [MeReadDtoLangEnum.Jp]: "ja",
};

type GetUserLocaleProps = {
  locale?: MeReadDtoLangEnum;
};

/**
 * Function to get the locale from the user's language
 * @param locale - The language of the user
 * @returns The locale of the user
 */
export const getUserLocale = ({ locale = "en" }: GetUserLocaleProps) => {
  if (mappingComplexLocales[locale]) {
    return mappingComplexLocales[locale];
  }

  return locale;
};
